import { motion } from 'framer-motion';
import { checkIcon as CheckIcon, features } from '../../data/landingData';
import { fadeInUp, staggerContainer } from '../../utils/motion';
import { PhoneMockup } from '../ui/PhoneMockup';
import { SectionTitle } from '../ui/SectionTitle';
import planesImg from '../../assets/feature_planes_de_entrenamiento.png';
import monitoreoImg from '../../assets/feature_monitoreo.png';
import prevencionImg from '../../assets/feature_prevencion.png';

export function FeaturesSection() {
  return (
    <section id="funcionalidades" className="bg-white py-16 sm:py-20">
      <div className="container-base">
        <SectionTitle
          title="Funcionalidades diseñadas para entrenar mejor"
          subtitle="Cada módulo responde al flujo real de trabajo de preparadores físicos, entrenadores y equipos de alto rendimiento."
          centered
        />

        <motion.div
          className="mt-12 space-y-16"
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.15 }}
        >
          {features.map((feature, index) => {
            const Icon = feature.icon;
            const isReverse = index % 2 === 1;

            return (
              <motion.article
                key={feature.title}
                variants={fadeInUp}
                transition={{ duration: 0.4 }}
                className={`grid items-center gap-8 lg:grid-cols-2 ${isReverse ? 'lg:[&>*:first-child]:order-2' : ''}`}
              >
                <div>
                  <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-brand-50 px-3 py-1 text-[20px] font-semibold leading-tight text-brand-700">
                    <Icon className="h-4 w-4" />
                    {feature.title}
                  </div>
                  <p className="text-base leading-relaxed text-slate-600">{feature.description}</p>
                  <ul className="mt-5 space-y-3">
                    {feature.bullets.map((item) => (
                      <li key={item} className="flex items-start gap-2 text-sm text-slate-700 sm:text-base">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="flex justify-center gap-3 sm:gap-5">
                  {feature.mockup === 'planning' ? (
                    <img 
                      src={planesImg} 
                      alt="Planes de entrenamiento" 
                      className="w-full max-w-[340px] sm:max-w-[400px] object-contain drop-shadow-xl"
                    />
                  ) : feature.mockup === 'monitoring' ? (
                    <img 
                      src={monitoreoImg} 
                      alt="Monitoreo de la carga" 
                      className="w-full max-w-[340px] sm:max-w-[400px] object-contain drop-shadow-xl"
                    />
                  ) : feature.mockup === 'injury' ? (
                    <img 
                      src={prevencionImg} 
                      alt="Prevención de lesiones" 
                      className="w-full max-w-[340px] sm:max-w-[400px] object-contain drop-shadow-xl"
                    />
                  ) : (
                    <>
                      <PhoneMockup variant={feature.mockup} rotate={isReverse ? 'sm:rotate-3' : 'sm:-rotate-3'} />
                      <PhoneMockup variant={feature.mockup} rotate={isReverse ? 'sm:-rotate-3' : 'sm:rotate-3'} />
                    </>
                  )}
                </div>
              </motion.article>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
